/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Adjusttitle2Inputs */

const zh_adminsubs_adjusttitle2 = /** @type {(inputs: Adminsubs_Adjusttitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理点数`)
};

const en_adminsubs_adjusttitle2 = /** @type {(inputs: Adminsubs_Adjusttitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Credits`)
};

const es_adminsubs_adjusttitle2 = /** @type {(inputs: Adminsubs_Adjusttitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionar créditos`)
};

/**
* | output |
* | --- |
* | "Manage Credits" |
*
* @param {Adminsubs_Adjusttitle2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_adjusttitle2 = /** @type {((inputs?: Adminsubs_Adjusttitle2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Adjusttitle2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_adjusttitle2(inputs)
	if (locale === "en") return en_adminsubs_adjusttitle2(inputs)
	return es_adminsubs_adjusttitle2(inputs)
});
export { adminsubs_adjusttitle2 as "adminSubs_adjustTitle" }